var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f00dfa471b3d3ff6ce717f98d3309b630c096ee5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["codebycorey@codebycorey"]={id:"f00dfa471b3d3ff6ce717f98d3309b630c096ee5"};
      